<template>
  <div>
    <van-popup v-model="wanliu" round class="wanliu-van-popup">
      <div class="wanliu-wrapper">
        <div class="close" @click="wanliu = false"></div>
        <div class="icon"></div>
        <div class="title">{{info.title}}</div>
        <div class="desc">{{info.desc}}</div>
        <div class="btn-group">
          <div @click="cancelHandler" class="leftbtn">{{info.leftBtn}}</div>
          <div @click="sureHandler" class="rightbtn">{{info.rightBtn}}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { GETCOURSE, SOURCEID } from '../const'

const Map = {
  0: {
    title: '还差一步就能领课成功',
    desc: '领课更能解锁抽奖等3重福利~',
    leftBtn: '忍痛离开',
    rightBtn: '继续领课'
  },
  1: {
    title: '确定不再看看了吗？',
    desc: '天天抽奖、携程精选等多重福利还在等你~',
    leftBtn: '确定离开',
    rightBtn: '我再看看'
  }
}

export default {
  name: '',
  props: {
    type: Number
  },
  computed: {
    ...mapState(['drawNum'])
  },
  watch: {
    type() {
      this.info = Map[this.type] || {}
    }
  },
  data() {
    return {
      info: {},
      wanliu: false
    }
  },
  created() {
    this.info = Map[this.type] || {}
    console.log(this.info)
  },
  methods: {
    // 忍痛离开
    cancelHandler() {
      this.wanliu = false
      window.xesApp && window.xesApp.goBack()
    },
    // 确认
    sureHandler() {
      this.wanliu = false

      if (this.type === 0) {
        // 领取课程  渠道号
        const { channelId = '' } = this.$route.query || {}
        window.location.href = `${GETCOURSE}&sourceId=${SOURCEID}&channelId=${channelId}`
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wanliu-van-popup {
  overflow-y: unset !important;

  .wanliu-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 590px/2;
    height: 412px/2;
    padding: 40px/2 40px/2;
    text-align: center;
    background: #fff;
    border-radius: 10px;
  }

  .icon {
    width: 33px;
    height: 33px;
    background: url(../assets/images/wanliu.png) no-repeat;
    background-size: cover;
  }

  .title {
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
    color: #90402c;
  }

  .desc {
    margin-top: 16px;
    font-size: 12px;
    color: #666;
  }

  .btn-group {
    display: flex;
    width: 100%;
    height: 70px/2;
    margin-top: 44px/2;

    div {
      flex: 1;
      width: 50%;
      height: 35px;
      margin-right: 15px;
      font-size: 30px/2;
      font-weight: 400;
      line-height: 35px;
      text-align: center;
      border-radius: 35px/2;
    }

    .leftbtn {
      color: #666;
      background: linear-gradient(-69deg, #f5f5f5 0%, #f0f0f0 100%);
    }

    .rightbtn {
      color: #fff;
      background: linear-gradient(-69deg, #e42225 0%, #ed4351 99%);
    }
  }
}
</style>
